import drawer from './drawer.vue'
drawer.install = function (Vue) {
  Vue.component(drawer.name, drawer);
};
export default drawer



// WEBPACK FOOTER //
// ./src/ni-ui/drawer/index.js